import { NgModule } from '@angular/core';
import { ApxRadioButtonComponent } from './radio-button/radio-button.component';
import { ApxRadioGroupComponent } from './radio-group.component';

@NgModule({
    imports: [ApxRadioGroupComponent, ApxRadioButtonComponent],
    exports: [ApxRadioGroupComponent, ApxRadioButtonComponent]
})
export class ApxRadioModule {}

// Re-export components for barrel exports
export { ApxRadioButtonComponent } from './radio-button/radio-button.component';
export { ApxRadioGroupComponent } from './radio-group.component';
